import Chart from "./chartConfig"
import parseColor from "parse-color"
import _ from "lodash"

interface compChartColorObj {
  spread1: compChartColorChildrenObj
  spread2: compChartColorChildrenObj
  sub1: compChartColorChildrenObj
  sub2: compChartColorChildrenObj
}

interface compChartColorChildrenObj {
  r: number
  g: number
  b: number
  a: number
}

interface Window {
  Trading: any
  IntelliFactory: any
}

declare var window: Window

const colorConv = (plotType: string, colorSetting: object): Function => {
  return (
    name: string,
    group: string,
    item: string,
    key?: string
  ): Array<any> => {
    let rgba
    // 騰落チャート（トップページ）は色固定
    if (
      (plotType === "LineFillByPrevClosePlot" && name === "AreaFill") ||
      name === "ChartFill"
    ) {
      const elements = document.querySelector("html").className.split(" ")
      if (_.includes(elements, "dark")) {
        rgba = _Color(Chart.defaultChartColorSettings.baseColor.area.ChartFill)
      } else {
        // 白モードのときはCSS側の指定で上書きする必要あり
        rgba = _Color("rgba(255,255,255,1)")
      }
    } else {
      rgba = _ColorName(name, group, item, colorSetting, key)
    }
    return [name, rgba]
  }
}

const _Color = (color: string) => {
  if (!color) color = "rgba(255,255,255,255)"
  let ColorDef = window.Trading.Chart.ColorDef
  let _parseColor = parseColor(color)
  if (!_parseColor) {
    return
  }
  let [r, g, b, a] = _parseColor.rgba
  return ColorDef["Color.FromArgbI.Static"](255 * a, r, g, b)
}

const initialColorSettings = (): any => {
  const elements = document.querySelector("html").className.split(" ")
  if (_.includes(elements, "dark")) {
    return Chart.defaultChartColorSettings
  } else {
    return Chart.defaultChartColorWhiteSettings
  }
}

const _ColorName = (
  name: string,
  group: string,
  item: string,
  colorSetting: object,
  key?: string
): any => {
  const lineName = name === "VwapTM1" || name === "VwapT0" ? "Vwap" : name
  key = !key && lineName
  let color = _.get(colorSetting, [group, item, key])
  if (!color) {
    color = _.get(Chart.defaultChartColorSettings, [group, item, key])
  }
  if (!color) {
    console.log(
      "_ColorName テクニカル名が不正です:",
      lineName,
      group,
      item,
      key
    )
    // 色追加した場合は、ローカル設定にデータがないので、黒を返すようにする
    color = "rgba(238, 0, 119,255)" // 赤
  }
  let colors = color.split(";")
  return _Color(colors[0])
}

const setColorPattern = (
  plotType: string,
  colorSetting: object,
  _controller: any
): void => {
  const _ColorConv = colorConv(plotType, colorSetting)
  let List = window.IntelliFactory.WebSharper.List
  let option = {
    Name: "",
    Key2Colors: List.ofArray([
      /**
       * 基本色
       */
      // グラフ表示エリア外の塗りつぶし
      // "ChartFill",Color.FromArgbI(255,240,240,240);
      _ColorConv("ChartFill", "baseColor", "area"),
      // チャート内のグラフ表示エリア塗りつぶし
      _ColorConv("AreaFill", "baseColor", "area"),
      _ColorConv("CrossCursolLine", "baseColor", "area"),
      _ColorConv("CrossCursolLblDraw", "baseColor", "area"),
      _ColorConv("CrossCursolLblFill", "baseColor", "area"),

      // 現値ラベル
      _ColorConv("CurPriceLblFill", "baseColor", "area"),
      _ColorConv("CurPriceLblDraw", "baseColor", "area"),

      //前日終値ライン
      _ColorConv("PrevDayCloseLine", "baseColor", "area"),
      _ColorConv("PrevDayCloseLblFill", "baseColor", "area"),
      _ColorConv("PrevDayCloseLblDraw", "baseColor", "area"),

      // チャート内の数値読み取り表示エリア枠
      // "AreaDraw",Color.FromArgbI(255,205,205,205);
      _ColorConv("AreaDraw", "baseColor", "area"),

      // チャート内のグラフ表示エリアグリッド
      // "Grid",Color.FromArgbI(255,205,205,205);
      _ColorConv("Grid", "baseColor", "area"),
      // //X軸、Y軸のラベル表示
      // "Label",Color.FromArgbI(255,0,0,0);
      _ColorConv("Label", "baseColor", "area"),
      // //グラフ表示エリアで銘柄名表示などに使われているが変更の可能性あり
      // "SubChartLabel",Color.FromArgbI(255,102,102,102);
      _ColorConv("SubChartLabel", "baseColor", "area"),
      // ChartWrapのtoScaleLineで使用しているが、DrawScaleLinesではGrid色を使っているのでどちらが有効か確認必要。
      // "CK_ScaleLine",Color.FromArgbI(255,205,205,205)
      _ColorConv("CK_ScaleLine", "baseColor", "area"),

      // スクロールバー
      // 背景塗りつぶし
      // "Scroll_Back",Color.FromArgbI(255,30,30,30)
      _ColorConv("Scroll_Back", "baseColor", "scrollbar"),
      // 表示範囲暗
      // "Scroll_ViewRange",Color.FromArgbI(100,255,180,0)
      _ColorConv("Scroll_ViewRange", "baseColor", "scrollbar"),
      // 表示範囲明
      // "Scroll_ViewRangeLight",Color.FromArgbI(150,255,180,0)
      _ColorConv("Scroll_ViewRangeLight", "baseColor", "scrollbar"),
      // データ塗りつぶし
      // "Scroll_Data",Color.FromArgbI(255,90,90,90)
      _ColorConv("Scroll_Data", "baseColor", "scrollbar"),
      // データライン
      // "Scroll_DataLine",Color.FromArgbI(255,255,255,255)
      _ColorConv("Scroll_DataLine", "baseColor", "scrollbar"),
      // ハンドルマーク
      // "Scroll_HandleMark",Color.FromArgbI(150,0,0,0)
      _ColorConv("Scroll_HandleMark", "baseColor", "scrollbar"),
      // ハンドルサイドノブ
      // "Scroll_HandleBorder",Color.FromArgbI(255,120,120,120)
      _ColorConv("Scroll_HandleBorder", "baseColor", "scrollbar"),

      // ローソク
      _ColorConv("Candle_DownArea", "baseColor", "candle"),
      // "Candle_DownFrame",Color.FromArgbI(255,0,0,255);
      _ColorConv("Candle_DownFrame", "baseColor", "candle"),
      // "Candle_UpArea",Color.FromArgbI(255,255,0,0);
      _ColorConv("Candle_UpArea", "baseColor", "candle"),
      // "Candle_UpFrame",Color.FromArgbI(255,255,0,0);
      _ColorConv("Candle_UpFrame", "baseColor", "candle"),

      // ライン
      // //Line
      // "Line_Line",Color.FromArgbI(255,0,0,255);
      _ColorConv("Line_Line", "baseColor", "line"),

      // グリッド、フィボナッチ
      _ColorConv("FiboExpansion", "toolColor", "Fibo"),
      _ColorConv("FiboTimeZone", "toolColor", "Fibo"),
      _ColorConv("FiboReTracement", "toolColor", "Fibo"),
      _ColorConv("GannFan", "toolColor", "Gann"),
      _ColorConv("GannGrid", "toolColor", "Gann"),

      _ColorConv("FiboFan", "toolColor", "Fibo"),
      _ColorConv("FiboArc", "toolColor", "Fibo"),

      // 窓
      _ColorConv("MadoBackGroundUp", "toolColor", "Mado"),
      _ColorConv("MadoBackGroundDown", "toolColor", "Mado"),
      _ColorConv("MadoValue", "toolColor", "Mado"),

      // エリアチャート
      // "LineFill_Line",Color.FromArgbI(255,0,255,255);
      _ColorConv("LineFill_Line", "baseColor", "lineFill"),
      // "LineFill_Top",Color.FromArgbI(120,0,0,255);
      _ColorConv("LineFill_Top", "baseColor", "lineFill"),
      // "LineFill_Bottom",Color.FromArgbI(255,255,0,0);
      _ColorConv("LineFill_Bottom", "baseColor", "lineFill"),

      _ColorConv("LineFill_LineSame", "baseColor", "lineFill"),
      _ColorConv("LineFill_TopSame", "baseColor", "lineFill"),
      _ColorConv("LineFill_BottomSame", "baseColor", "lineFill"),

      _ColorConv("LineFill_LineUp", "baseColor", "lineFill"),
      _ColorConv("LineFill_TopUp", "baseColor", "lineFill"),
      _ColorConv("LineFill_BottomUp", "baseColor", "lineFill"),

      _ColorConv("LineFill_LineDown", "baseColor", "lineFill"),
      _ColorConv("LineFill_TopDown", "baseColor", "lineFill"),
      _ColorConv("LineFill_BottomDown", "baseColor", "lineFill"),

      /**
       * ツール系
       */
      // PointAndFigure 下降
      _ColorConv("PAndF_Down", "toolColor", "PandF"),
      // PointAndFigure 上昇
      _ColorConv("PAndF_Up", "toolColor", "PandF"),

      _ColorConv("PriceVolume", "addon", "PriceVolume"),
      _ColorConv("PvMaxVolume", "addon", "PriceVolume"),
      _ColorConv("PvMaxNum", "addon", "PriceVolume"),
      _ColorConv("PvMaxNumBack", "addon", "PriceVolume"),
      _ColorConv("CycleHigh", "addon", "CycleAna"),
      _ColorConv("CycleLow", "addon", "CycleAna"),
      _ColorConv("CycleHighFont", "addon", "CycleAna"),
      _ColorConv("CycleLowFont", "addon", "CycleAna"),

      // トレンドライン
      // "TrendLine",Color.FromArgbI(255,0,0,0);
      _ColorConv("TrendLine", "toolColor", "trendLine"),
      // 操作対象のトレンドラインマーク
      // "CK_HANDLINGDRAINGITEM",Color.FromArgbI(255,0,0,0)
      _ColorConv("CK_HANDLINGDRAINGITEM", "toolColor", "trendLine"),

      // 以下転換の色に関しては使うRendererによる可能性ありあり。
      // //転換の文字色
      // "Tenkan_Label",Color.FromArgbI(255,0,0,0)
      _ColorConv("Tenkan_Label", "addon", "tenkan"),
      // おそらく未使用
      // "Tenkan_Draw",Color.FromArgbI(255,205,205,205)
      // _ColorConv("Tenkan_Draw", "addon", "tenkan"),
      // //転換の塗りつぶし
      // "Tenkan_Fill",Color.FromArgbI(255,230,230,230)
      _ColorConv("Tenkan_Fill", "addon", "tenkan"),

      // ルーペの範囲選択枠
      // "CK_LOUPEFRAME",Color.FromArgbI(255,0,0,0)
      _ColorConv("CK_LOUPEFRAME", "toolColor", "loupe"),
      _ColorConv("CK_LOUPE_RESET", "toolColor", "loupe"),
      // Y軸のMinMax、X軸のMax操作時のマーク
      // "CK_INNERAREAHANDLE",Color.FromArgbI(255,0,0,0)
      _ColorConv("CK_INNERAREAHANDLE", "toolColor", "control"),
    ]),
    IndKey2Colors: List.ofArray([
      /**
       * アドオンチャート
       */
      // 単純移動平均
      [
        "Average3",
        List.ofArray([
          _ColorConv("Long", "addon", "Average3"),
          _ColorConv("Middle", "addon", "Average3"),
          _ColorConv("Short", "addon", "Average3"),
        ]),
      ],
      // 単純移動平均5本
      [
        "AverageN",
        List.ofArray([
          _ColorConv("Ma1", "addon", "AverageN"),
          _ColorConv("Ma2", "addon", "AverageN"),
          _ColorConv("Ma3", "addon", "AverageN"),
          _ColorConv("Ma4", "addon", "AverageN"),
          _ColorConv("Ma5", "addon", "AverageN"),
        ]),
      ],
      // ATRチャネル
      [
        "ATRChannel",
        List.ofArray([
          _ColorConv("ATRChannelSigma1", "addon", "ATRChannel"),
          _ColorConv("ATRChannelSigma1m", "addon", "ATRChannel"),
          _ColorConv("ATRChannelSigma2", "addon", "ATRChannel"),
          _ColorConv("ATRChannelSigma2m", "addon", "ATRChannel"),
          _ColorConv("ATRChannelSigma3", "addon", "ATRChannel"),
          _ColorConv("ATRChannelSigma3m", "addon", "ATRChannel"),
          _ColorConv("Lma", "addon", "ATRChannel"),
        ]),
      ],
      // 指数平滑移動平均線
      [
        "EMA",
        List.ofArray([
          _ColorConv("Long", "addon", "EMA"),
          _ColorConv("Middle", "addon", "EMA"),
          _ColorConv("Short", "addon", "EMA"),
        ]),
      ],
      // 回帰トレンド
      [
        "Kaiki",
        List.ofArray([
          _ColorConv("KaikiSigma1", "addon", "Kaiki"),
          _ColorConv("KaikiSigma1m", "addon", "Kaiki"),
          _ColorConv("KaikiSigma2", "addon", "Kaiki"),
          _ColorConv("KaikiSigma2m", "addon", "Kaiki"),
          _ColorConv("KaikiSigma3", "addon", "Kaiki"),
          _ColorConv("KaikiSigma3m", "addon", "Kaiki"),
          _ColorConv("Kaiki", "addon", "Kaiki"),
        ]),
      ],
      // Vwap
      [
        "Vwap",
        List.ofArray([
          _ColorConv("Vwap", "addon", "Vwap"),
          _ColorConv("VwapTM1", "addon", "Vwap"),
          _ColorConv("VwapT0", "addon", "Vwap"),
        ]),
      ],
      // 一目均衡表
      [
        "Ichimoku",
        List.ofArray([
          _ColorConv("DelayLine", "addon", "Ichimoku"),
          _ColorConv("KijunLine", "addon", "Ichimoku"),
          _ColorConv("Kumo", "addon", "Ichimoku"),
          _ColorConv("Kumo2", "addon", "Ichimoku"),
          _ColorConv("PrecedLine1", "addon", "Ichimoku"),
          _ColorConv("PrecedLine2", "addon", "Ichimoku"),
          _ColorConv("TenkanLine", "addon", "Ichimoku"),
        ]),
      ],
      // エンベロープ
      [
        "Envelope",
        List.ofArray([
          _ColorConv("EnvSigma1", "addon", "Envelope"),
          _ColorConv("EnvSigma1m", "addon", "Envelope"),
          _ColorConv("EnvSigma2", "addon", "Envelope"),
          _ColorConv("EnvSigma2m", "addon", "Envelope"),
          _ColorConv("EnvSigma3", "addon", "Envelope"),
          _ColorConv("EnvSigma3m", "addon", "Envelope"),
          _ColorConv("Sma", "addon", "Envelope"),
        ]),
      ],
      // ボリンジャーバンド
      [
        "KSBolinger",
        List.ofArray([
          _ColorConv("BolSigma1", "addon", "KSBolinger"),
          _ColorConv("BolSigma1m", "addon", "KSBolinger"),
          _ColorConv("BolSigma2", "addon", "KSBolinger"),
          _ColorConv("BolSigma2m", "addon", "KSBolinger"),
          _ColorConv("BolSigma3", "addon", "KSBolinger"),
          _ColorConv("BolSigma3m", "addon", "KSBolinger"),
          _ColorConv("Sma", "addon", "KSBolinger"),
        ]),
      ],
      // パラボリック
      [
        "ParabolicDiv",
        List.ofArray([
          _ColorConv("CircleBuy", "addon", "ParabolicDiv"),
          _ColorConv("CircleSell", "addon", "ParabolicDiv"),
        ]),
      ],
      // HLバンド
      [
        "HLBand",
        List.ofArray([
          _ColorConv("Center", "addon", "HLBand"),
          _ColorConv("HLine", "addon", "HLBand"),
          _ColorConv("LLine", "addon", "HLBand"),
        ]),
      ],

      /**
       * サブチャート
       */
      // RSI
      ["RSI", List.ofArray([_ColorConv("RSI", "sub", "RSI")])],
      // ストキャスティクス
      [
        "StocastKD",
        List.ofArray([
          _ColorConv("PercentD", "sub", "StocastKD"),
          _ColorConv("PercentK", "sub", "StocastKD"),
        ]),
      ],
      [
        "StocastDS",
        List.ofArray([
          _ColorConv("PercentD", "sub", "StocastDS"),
          _ColorConv("SPercentD", "sub", "StocastDS"),
        ]),
      ],
      // %R
      ["PercentR", List.ofArray([_ColorConv("PercentR", "sub", "PercentR")])],
      // MACD
      [
        "MACD",
        List.ofArray([
          _ColorConv("MACD", "sub", "MACD"),
          _ColorConv("OSCI", "sub", "MACD"),
          _ColorConv("Signal", "sub", "MACD"),
        ]),
      ],
      // RCI3
      [
        "RCI3",
        List.ofArray([
          _ColorConv("RCI1", "sub", "RCI3"),
          _ColorConv("RCI2", "sub", "RCI3"),
          _ColorConv("RCI3", "sub", "RCI3"),
        ]),
      ],
      // CCI
      ["CCI", List.ofArray([_ColorConv("CCI", "sub", "CCI")])],
      // サイコロジカル
      [
        "PsyCologic",
        List.ofArray([_ColorConv("PsyCologic", "sub", "PsyCologic")]),
      ],
      // ROC2
      [
        "ROC2",
        List.ofArray([
          _ColorConv("ROC1", "sub", "ROC2"),
          _ColorConv("ROC2", "sub", "ROC2"),
          _ColorConv("Signal", "sub", "ROC2"),
        ]),
      ],
      // ATR
      ["ATR", List.ofArray([_ColorConv("ATR", "sub", "ATR")])],
      // ["ATRBand", List.ofArray([
      //   _ColorConv("ATRBand", "sub", "baseAreaIn"),
      //   _ColorConv("ATRBandm", "sub", "baseAreaIn"),
      //   _ColorConv("mvav", "sub", "baseAreaIn"),
      // ])],
      // モメンタム
      [
        "MomentumS",
        List.ofArray([
          _ColorConv("Momentum", "sub", "MomentumS"),
          _ColorConv("Signal", "sub", "MomentumS"),
        ]),
      ],
      // DMI（修正ADX）
      [
        "DMImod",
        List.ofArray([
          _ColorConv("+DI", "sub", "DMImod"),
          _ColorConv("-DI", "sub", "DMImod"),
          _ColorConv("ADX1", "sub", "DMImod"),
          _ColorConv("ADXR1", "sub", "DMImod"),
          _ColorConv("ADX2", "sub", "DMImod"),
          _ColorConv("ADXR2", "sub", "DMImod"),
        ]),
      ],
      // 標準偏差ボラティリティ
      [
        "StandardDeviation",
        List.ofArray([
          _ColorConv("StandardDeviation", "sub", "StandardDeviation"),
        ]),
      ],
      // 強弱レシオ
      [
        "HinoharaRatio",
        List.ofArray([
          _ColorConv("RatioA", "sub", "HinoharaRatio"),
          _ColorConv("RatioB", "sub", "HinoharaRatio"),
        ]),
      ],
      // アルーン・インジケーター
      [
        "AroonIndi",
        List.ofArray([
          _ColorConv("AroonDown", "sub", "AroonIndi"),
          _ColorConv("AroonUp", "sub", "AroonIndi"),
        ]),
      ],
      // アルーン・オシレーター
      [
        "AroonOsci",
        List.ofArray([_ColorConv("AroonOsci", "sub", "AroonOsci")]),
      ],
      // 移動平均乖離率
      [
        "Kairi3",
        List.ofArray([
          _ColorConv("Long", "sub", "Kairi3"),
          _ColorConv("Middle", "sub", "Kairi3"),
          _ColorConv("Short", "sub", "Kairi3"),
        ]),
      ],
      // 信用残
      [
        "信用残",
        List.ofArray([
          _ColorConv("MarginBuying", "sub", "SinyouZan"),
          _ColorConv("MarginSelling", "sub", "SinyouZan"),
        ]),
      ],
      // 売買高
      [
        "Volume",
        List.ofArray([
          _ColorConv("Long", "sub", "Volume"),
          _ColorConv("Middle", "sub", "Volume"),
          _ColorConv("Short", "sub", "Volume"),
          _ColorConv("Today", "sub", "Volume"),
          _ColorConv("Volume", "sub", "Volume"),
        ]),
      ],
      [
        "VolumeMa3",
        List.ofArray([
          _ColorConv("Long", "sub", "Volume"),
          _ColorConv("Middle", "sub", "Volume"),
          _ColorConv("Short", "sub", "Volume"),
          _ColorConv("Today", "sub", "Volume"),
          _ColorConv("Volume", "sub", "Volume"),
        ]),
      ],
    ]),
  }
  if (!_controller || !_controller.Chart) return

  window.Trading.Chart.Proto.Util.setColorPattern(option)
  _controller.Chart.SetColor(option)
  _controller.Chart.SetLineWidth(LineWidth(colorSetting))
  _controller.Chart.Draw()
}

const LineWidth = (colorSetting: object) => {
  const _LineWidthConv = LineWidthConv(colorSetting)
  let List = window.IntelliFactory.WebSharper.List
  return List.ofArray([
    // 単純移動平均5本
    [
      "AverageN",
      List.ofArray([
        _LineWidthConv("Ma1", "addon", "AverageN"),
        _LineWidthConv("Ma2", "addon", "AverageN"),
        _LineWidthConv("Ma3", "addon", "AverageN"),
        _LineWidthConv("Ma4", "addon", "AverageN"),
        _LineWidthConv("Ma5", "addon", "AverageN"),
      ]),
    ],
    // ATRチャネル
    [
      "ATRChannel",
      List.ofArray([
        _LineWidthConv("ATRChannelSigma1", "addon", "ATRChannel"),
        _LineWidthConv("ATRChannelSigma1m", "addon", "ATRChannel"),
        _LineWidthConv("ATRChannelSigma2", "addon", "ATRChannel"),
        _LineWidthConv("ATRChannelSigma2m", "addon", "ATRChannel"),
        _LineWidthConv("ATRChannelSigma3", "addon", "ATRChannel"),
        _LineWidthConv("ATRChannelSigma3m", "addon", "ATRChannel"),
        _LineWidthConv("Lma", "addon", "ATRChannel"),
      ]),
    ],
    // 指数平滑移動平均線
    [
      "EMA",
      List.ofArray([
        _LineWidthConv("Long", "addon", "EMA"),
        _LineWidthConv("Middle", "addon", "EMA"),
        _LineWidthConv("Short", "addon", "EMA"),
      ]),
    ],
    // 回帰トレンド
    [
      "Kaiki",
      List.ofArray([
        _LineWidthConv("KaikiSigma1", "addon", "Kaiki"),
        _LineWidthConv("KaikiSigma1m", "addon", "Kaiki"),
        _LineWidthConv("KaikiSigma2", "addon", "Kaiki"),
        _LineWidthConv("KaikiSigma2m", "addon", "Kaiki"),
        _LineWidthConv("KaikiSigma3", "addon", "Kaiki"),
        _LineWidthConv("KaikiSigma3m", "addon", "Kaiki"),
        _LineWidthConv("Kaiki", "addon", "Kaiki"),
      ]),
    ],
    // Vwap
    // Vwap
    [
      "Vwap",
      List.ofArray([
        _LineWidthConv("Vwap", "addon", "Vwap"),
        _LineWidthConv("VwapTM1", "addon", "Vwap"),
        _LineWidthConv("VwapT0", "addon", "Vwap"),
      ]),
    ],
    // 一目均衡表
    [
      "Ichimoku",
      List.ofArray([
        _LineWidthConv("DelayLine", "addon", "Ichimoku"),
        _LineWidthConv("KijunLine", "addon", "Ichimoku"),
        // そのうち先行スパンも実行できるように、コメントで残しておく
        // _LineWidthConv("PrecedLine1", "addon", "Ichimoku"), // 雲１と雲２と先行スパンは変更しない(変更すると雲がきえる）
        // _LineWidthConv("PrecedLine2", "addon", "Ichimoku"), // 雲１と雲２と先行スパンは変更しない(変更すると雲がきえる）
        _LineWidthConv("TenkanLine", "addon", "Ichimoku"),
      ]),
    ],
    // エンベロープ
    [
      "Envelope",
      List.ofArray([
        _LineWidthConv("EnvSigma1", "addon", "Envelope"),
        _LineWidthConv("EnvSigma1m", "addon", "Envelope"),
        _LineWidthConv("EnvSigma2", "addon", "Envelope"),
        _LineWidthConv("EnvSigma2m", "addon", "Envelope"),
        _LineWidthConv("EnvSigma3", "addon", "Envelope"),
        _LineWidthConv("EnvSigma3m", "addon", "Envelope"),
        _LineWidthConv("Sma", "addon", "Envelope"),
      ]),
    ],
    // ボリンジャーバンド
    [
      "KSBolinger",
      List.ofArray([
        _LineWidthConv("BolSigma1", "addon", "KSBolinger"),
        _LineWidthConv("BolSigma1m", "addon", "KSBolinger"),
        _LineWidthConv("BolSigma2", "addon", "KSBolinger"),
        _LineWidthConv("BolSigma2m", "addon", "KSBolinger"),
        _LineWidthConv("BolSigma3", "addon", "KSBolinger"),
        _LineWidthConv("BolSigma3m", "addon", "KSBolinger"),
        _LineWidthConv("Sma", "addon", "KSBolinger"),
      ]),
    ],
    // HLバンド
    [
      "HLBand",
      List.ofArray([
        _LineWidthConv("Center", "addon", "HLBand"),
        _LineWidthConv("HLine", "addon", "HLBand"),
        _LineWidthConv("LLine", "addon", "HLBand"),
      ]),
    ],

    /**
     * サブチャート
     */
    // RSI
    ["RSI", List.ofArray([_LineWidthConv("RSI", "sub", "RSI")])],
    // ストキャスティクス
    [
      "StocastKD",
      List.ofArray([
        _LineWidthConv("PercentD", "sub", "StocastKD"),
        _LineWidthConv("PercentK", "sub", "StocastKD"),
      ]),
    ],
    [
      "StocastDS",
      List.ofArray([
        _LineWidthConv("PercentD", "sub", "StocastDS"),
        _LineWidthConv("SPercentD", "sub", "StocastDS"),
      ]),
    ],
    // %R
    ["PercentR", List.ofArray([_LineWidthConv("PercentR", "sub", "PercentR")])],
    // MACD
    [
      "MACD",
      List.ofArray([
        _LineWidthConv("MACD", "sub", "MACD"),
        _LineWidthConv("OSCI", "sub", "MACD"),
        _LineWidthConv("Signal", "sub", "MACD"),
      ]),
    ],
    // RCI3
    [
      "RCI3",
      List.ofArray([
        _LineWidthConv("RCI1", "sub", "RCI3"),
        _LineWidthConv("RCI2", "sub", "RCI3"),
        _LineWidthConv("RCI3", "sub", "RCI3"),
      ]),
    ],
    // CCI
    ["CCI", List.ofArray([_LineWidthConv("CCI", "sub", "CCI")])],
    // サイコロジカル
    [
      "PsyCologic",
      List.ofArray([_LineWidthConv("PsyCologic", "sub", "PsyCologic")]),
    ],
    // ROC2
    [
      "ROC2",
      List.ofArray([
        _LineWidthConv("ROC1", "sub", "ROC2"),
        _LineWidthConv("ROC2", "sub", "ROC2"),
        _LineWidthConv("Signal", "sub", "ROC2"),
      ]),
    ],
    // ATR
    ["ATR", List.ofArray([_LineWidthConv("ATR", "sub", "ATR")])],
    // モメンタム
    [
      "MomentumS",
      List.ofArray([
        _LineWidthConv("Momentum", "sub", "MomentumS"),
        _LineWidthConv("Signal", "sub", "MomentumS"),
      ]),
    ],
    // DMI（修正ADX）
    [
      "DMImod",
      List.ofArray([
        _LineWidthConv("+DI", "sub", "DMImod"),
        _LineWidthConv("-DI", "sub", "DMImod"),
        _LineWidthConv("ADX1", "sub", "DMImod"),
        _LineWidthConv("ADXR1", "sub", "DMImod"),
        _LineWidthConv("ADX2", "sub", "DMImod"),
        _LineWidthConv("ADXR2", "sub", "DMImod"),
      ]),
    ],
    // 標準偏差ボラティリティ
    [
      "StandardDeviation",
      List.ofArray([
        _LineWidthConv("StandardDeviation", "sub", "StandardDeviation"),
      ]),
    ],
    // 強弱レシオ
    [
      "HinoharaRatio",
      List.ofArray([
        _LineWidthConv("RatioA", "sub", "HinoharaRatio"),
        _LineWidthConv("RatioB", "sub", "HinoharaRatio"),
      ]),
    ],
    // アルーン・インジケーター
    [
      "AroonIndi",
      List.ofArray([
        _LineWidthConv("AroonDown", "sub", "AroonIndi"),
        _LineWidthConv("AroonUp", "sub", "AroonIndi"),
      ]),
    ],
    // アルーン・オシレーター
    [
      "AroonOsci",
      List.ofArray([_LineWidthConv("AroonOsci", "sub", "AroonOsci")]),
    ],
    // 移動平均乖離率
    [
      "Kairi3",
      List.ofArray([
        _LineWidthConv("Long", "sub", "Kairi3"),
        _LineWidthConv("Middle", "sub", "Kairi3"),
        _LineWidthConv("Short", "sub", "Kairi3"),
      ]),
    ],
    // 信用残
    [
      "信用残",
      List.ofArray([
        _LineWidthConv("MarginBuying", "sub", "SinyouZan"),
        _LineWidthConv("MarginSelling", "sub", "SinyouZan"),
      ]),
    ],
    // 売買高
    [
      "Volume",
      List.ofArray([
        _LineWidthConv("Long", "sub", "Volume"),
        _LineWidthConv("Middle", "sub", "Volume"),
        _LineWidthConv("Short", "sub", "Volume"),
        _LineWidthConv("Volume", "sub", "Volume"),
      ]),
    ],
    [
      "VolumeMa3",
      List.ofArray([
        _LineWidthConv("Long", "sub", "Volume"),
        _LineWidthConv("Middle", "sub", "Volume"),
        _LineWidthConv("Short", "sub", "Volume"),
        _LineWidthConv("Volume", "sub", "Volume"),
      ]),
    ],
  ])
}

const LineWidthConv = (colorSetting: object): Function => {
  return (key: string, group: string, item: string) => {
    const lineName = key === "VwapTM1" || key === "VwapT0" ? "Vwap" : key
    let color = _.get(colorSetting, [group, item, lineName])
    if (!color) {
      color = _.get(Chart.defaultChartColorSettings, [group, item, lineName])
    }
    if (!color) {
      console.log(
        "_LineWidthConv: テクニカル名が不正です:",
        lineName,
        group,
        item
      )
    }
    let colors = color.split(";")
    let lw = 1.0
    if (colors.length > 1) lw = lw * colors[1]
    return [key, lw]
  }
}
const setCompChartColor = (colorSetting: object): Function => {
  return (): object => {
    let sub1 = _ColorName("subBrand1", "baseColor", "compChart", colorSetting)
    let sub2 = _ColorName("subBrand2", "baseColor", "compChart", colorSetting)
    let sp1 = _ColorName("Spread1", "sub", "Spread", colorSetting)
    let sp2 = _ColorName("Spread2", "sub", "Spread", colorSetting)
    return {
      spread1: {
        r: sp1.R,
        g: sp1.G,
        b: sp1.B,
        a: sp1.A,
      },
      spread2: {
        r: sp2.R,
        g: sp2.G,
        b: sp2.B,
        a: sp2.A,
      },
      sub1: {
        r: sub1.R,
        g: sub1.G,
        b: sub1.B,
        a: sub1.A,
      },
      sub2: {
        r: sub2.R,
        g: sub2.G,
        b: sub2.B,
        a: sub2.A,
      },
    }
  }
}

const mdnIndColor = (
  subBrandId: Array<any>,
  compChartColor: compChartColorObj
): Function => {
  return (nIdV: number): any => {
    let color = subBrandId[0]
      ? nIdV === subBrandId[0].id
        ? compChartColor.spread1
        : compChartColor.spread2
      : compChartColor.spread2 // サブ銘柄１は未設定なので、スプレッド２の色が該当
    return window.IntelliFactory.Runtime.Tupled(function() {
      return window.Trading.Chart.ColorDef["Color.FromArgbI.Static"](
        color.a,
        color.r,
        color.g,
        color.b
      )
    })
  }
}

const nodePlot = (subBrandId: any, compChartColor: compChartColorObj) => {
  return (nId: number): any => {
    const idList = subBrandId.getSubBrandId()
    let color = idList[0]
      ? nId === idList[0].id
        ? compChartColor.sub1
        : compChartColor.sub2
      : compChartColor.sub2 // サブ銘柄１は未設定なので、サブ銘柄２の色が該当

    return {
      $: 1,
      $0: () => {
        return window.Trading.Chart.ColorDef["Color.FromArgbI.Static"](
          color.a,
          color.r,
          color.g,
          color.b
        )
      },
      $1: 2,
    }
  }
}

const chartColors = {
  initialize: () => initialColorSettings(),
  setCompChartColor,
  mdnIndColor,
  nodePlot,
  setColorPattern,
  _ColorName,
}

export const colorReset = (colorSetting: object, newColors: object) => {
  const _colorSetting = _.clone(colorSetting)
  _.forEach(newColors, (propety, propetyKey) => {
    _.forEach(propety, (option: object, optionKey) => {
      _.forEach(option, (item, key) => {
        _.set(_colorSetting, [propetyKey, optionKey, key], item)
      })
    })
  })
  return _colorSetting
}

export default chartColors
